export function AllowDivElement(editor) {
    var allowedAttributes = ['id'];
    // Allow <div> elements in the model.
    editor.model.schema.register('div', {
        allowWhere: '$block',
        allowContentOf: '$root'
    });
    // The view-to-model converter converting a view <div> with all its attributes to the model.
    editor.conversion.for('upcast').elementToElement({
        view: 'div',
        model: 'div'
    });
    // The model-to-view converter for the <div> element (attributes are converted separately).
    editor.conversion.for('downcast').elementToElement({
        model: 'div',
        view: 'div'
    });
    editor.model.schema.extend('$root', { allowAttributes: allowedAttributes });
    editor.model.schema.extend('$block', { allowAttributes: allowedAttributes });
    for (var i = 0; i < allowedAttributes.length; i++) {
        editor.conversion.attributeToAttribute({ model: allowedAttributes[i], view: allowedAttributes[i] });
    }
    // Allow <div> elements in the model to have all attributes.
    editor.model.schema.addAttributeCheck(function (context) {
        if (context.endsWith('div')) {
            return true;
        }
    });
    // The model-to-view converter for <div> attributes.
    // Note that a lower-level, event-based API is used here.
    editor.conversion.for('downcast').add(function (dispatcher) {
        dispatcher.on('attribute', function (evt, data, conversionApi) {
            // Convert <div> attributes only.
            if (data.item.name != 'div') {
                return;
            }
            var viewWriter = conversionApi.writer;
            var viewDiv = conversionApi.mapper.toViewElement(data.item);
            // In the model-to-view conversion we convert changes.
            // An attribute can be added or removed or changed.
            // The below code handles all 3 cases.
            if (data.attributeNewValue) {
                viewWriter.setAttribute(data.attributeKey, data.attributeNewValue, viewDiv);
            }
            else {
                viewWriter.removeAttribute(data.attributeKey, viewDiv);
            }
        });
    });
}
export function AllowIDAttribute(editor) {
    var allowedAttributes = ['id'];
    editor.model.schema.extend('$root', { allowAttributes: allowedAttributes });
    editor.model.schema.extend('$block', { allowAttributes: allowedAttributes });
    for (var i = 0; i < allowedAttributes.length; i++) {
        editor.conversion.attributeToAttribute({ model: allowedAttributes[i], view: allowedAttributes[i] });
    }
}
//# sourceMappingURL=CustomCKEditor.js.map


//////////////////
// WEBPACK FOOTER
// ./src/app/customerservice/ckeditor5/src/CustomCKEditor.js
// module id = null
// module chunks = 